import { IoIosHelpBuoy } from 'react-icons/io'
const Help = ({ handleHelp }) => {
  return (
    <div className="mr-6 mb-2" style={{ textAlign: 'end' }}>
      <button className="ml-4" onClick={() => handleHelp(true)}>
        <span className="icon has-text-link is-size-1">
          <IoIosHelpBuoy />
        </span>
      </button>
    </div>
  )
}

export default Help
